<template>
  <v-card
    outlined
    elevation="4"
    :class="isLast ? 'mb-0' : 'mb-5'"
  >
    <v-card-title class="pl-3">
      {{ titulo }}
    </v-card-title>

    <v-card-text class="px-3 pb-0">
      <v-row class="d-flex align-center">
        <v-col
          v-if="isLast"
          cols="12"
        >
          <v-select
            v-model="state.idElementoTipo"
            dense
            outlined
            label="Tipo de componente:"
            hide-details
            validate-on-blur
            item-text="nome"
            item-value="id"
            :items="state.tiposDeComponentesEncadeaveis"
            :rules="[validators.select]"
            @change="v => updateComponente('idElementoTipo', v)"
          />
        </v-col>

        <v-col
          md="6"
          cols="12"
        >
          <v-text-field
            v-model="state.nome"
            dense
            outlined
            label="Nome:"
            counter="20"
            hint="Máximo de 20 caracteres"
            persistent-hint
            validate-on-blur
            :rules="[validators.required]"
            @change="v => updateComponente('nome', v)"
          />
        </v-col>

        <v-col
          md="6"
          cols="12"
        >
          <v-text-field
            v-model="state.label"
            dense
            outlined
            label="Label:"
            counter="500"
            hint="Máximo de 500 caracteres"
            persistent-hint
            validate-on-blur
            :rules="[validators.required]"
            @change="v => updateComponente('label', v)"
          />
        </v-col>

        <v-col cols="auto">
          <v-checkbox
            v-if="!isLabel"
            v-model="state.obrigatorio"
            class="mt-0"
            label="Obrigatório"
            @change="v => updateComponente('obrigatorio', v)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { required, select } from '@core/utils/validation'
import { ref, watchEffect, computed } from '@vue/composition-api'
import TiposDeComponentesEnum from '@/models/entities/formulario/componente/TiposDeComponentesEnum'

export default {
  props: {
    index: {
      type: Number,
      required: true,
      validator: value => value >= 0 && value <= 4,
    },
    isLast: Boolean,
    idElementoTipo: {
      type: Number,
      default: 0,
    },
    nome: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    obrigatorio: Boolean,
    tiposDeComponentesEncadeaveis: {
      type: Array,
      default: () => [],
    },
  },

  setup(props, { emit }) {
    const state = ref({})
    watchEffect(() => {
      state.value = {
        idElementoTipo: props.idElementoTipo,
        nome: props.nome,
        label: props.label,
        obrigatorio: props.obrigatorio,
        tiposDeComponentesEncadeaveis: props.tiposDeComponentesEncadeaveis,
      }
    })

    function updateComponente(field, value) { emit(`update:${field}`, value) }

    const titulo = computed(() => `${props.index + 1} : ${props.isLast ? 'Componente' : 'Drop-down List'}`)
    const isLabel = computed(() => state.value.idElementoTipo === TiposDeComponentesEnum.Label)

    return {
      state,
      updateComponente,
      titulo,
      isLabel,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
